require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpeproclublaunchreport.json") })
        }
      }, "path---winpeproclublaunchreport");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpeproclublaunchreport!./.cache/json/winpeproclublaunchreport.json
// module id = 1255
// module chunks = 231608221292675